var cov_1pwl1oadmb = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/context/index.ts",
      hash = "b3330deb486949ab82f7aeef9b921ed11831273c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/context/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

// copy from https://github.com/jamiebuilds/create-react-context
// Solve the version conflict between create-react-context and react17
import React from 'react';
export default React.createContext;